import React, { type ReactNode } from 'react';
import { GrowingScrollableSection } from '../styled.tsx';

export const NotFoundState = ({ children }: { children: ReactNode }) => (
	<GrowingScrollableSection>{children}</GrowingScrollableSection>
);
